/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Stage_Verify_DescInputs */

const en_directory_detail_signals_ai_stage_verify_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured output, success signals, rate limits, and versioning an agent can check its work against.`)
};

const zh_directory_detail_signals_ai_stage_verify_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化输出、成功信号、速率限制与版本管理，供 Agent 核对自己的工作结果。`)
};

/**
* | output |
* | --- |
* | "Structured output, success signals, rate limits, and versioning an agent can check its work against." |
*
* @param {Directory_Detail_Signals_Ai_Stage_Verify_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_stage_verify_desc = /** @type {((inputs?: Directory_Detail_Signals_Ai_Stage_Verify_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Stage_Verify_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_stage_verify_desc(inputs)
	return zh_directory_detail_signals_ai_stage_verify_desc(inputs)
});
export { directory_detail_signals_ai_stage_verify_desc as "directory.detail.signals.ai_stage.verify_desc" }